import {TransportFormat, WINDOW_KEY} from './types';

export default function initConsumer(push: (s: TransportFormat) => void): void {
    const queue = window[WINDOW_KEY];
    window[WINDOW_KEY] = {push};
    if (queue && Array.isArray(queue) && queue.length > 0) {
        queue.forEach(push);
    }
}
